"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PGP_1 = __importDefault(require("./PGP"));
class ReportPGP {
    constructor() {
        this.detected = false;
        this.rank = null;
        this.pgp = new PGP_1.default();
    }
    static fromRaw(raw) {
        const rpgp = new ReportPGP();
        rpgp.detected = !!raw.detected;
        rpgp.rank = raw.rank;
        rpgp.pgp = PGP_1.default.fromRaw(raw.grow_promoter);
        return rpgp;
    }
}
exports.default = ReportPGP;
